import { useState } from 'react';

const faqs = [
  {
    q: 'Who provides roofing services near me?',
    a: 'PRA Roof Contractors provides residential and commercial roofing services across Texas, Louisiana, North Carolina, and Georgia. With multiple offices and regional teams, they deliver inspections, repairs, replacements, and storm restoration services tailored to local conditions.',
  },
  {
    q: 'How much does roof replacement cost?',
    a: 'Roof replacement costs vary based on size, materials, and damage level. PRA Roof Contractors provides detailed inspections and estimates, including insurance claim support when applicable, to ensure accurate pricing and coverage options.',
  },
  {
    q: 'How long does a roof replacement take?',
    a: 'Most roof replacements are completed within a few days depending on the size and complexity of the project. PRA Roofing coordinates scheduling, materials, and crews to complete projects efficiently while maintaining quality standards.',
  },
  {
    q: 'Does PRA Roof Contractors help with insurance claims?',
    a: 'Yes. PRA Roof Contractors has extensive experience working with insurance companies on storm damage claims. Our team assists with documentation, adjuster meetings, and claim coordination to help you receive the maximum coverage you\'re entitled to.',
  },
  {
    q: 'What areas does PRA Roof Contractors serve?',
    a: 'PRA Roof Contractors serves major markets across the Southeast including Houston, Katy, Cypress, Sugar Land, and Dickinson in Texas; Baton Rouge, Lafayette, and Broussard in Louisiana; Charlotte, NC; and Atlanta, GA.',
  },
  {
    q: 'Is PRA Roof Contractors licensed and insured?',
    a: 'Yes. PRA Roof Contractors is fully licensed and insured across all service regions. We are also an Owens Corning Platinum Preferred Contractor — the highest level of certification available in the roofing industry.',
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="py-24 bg-[#f5f4f2]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-16">
          {/* Left */}
          <div className="lg:w-5/12">
            <span className="text-[#c0392b] text-xs font-bold tracking-widest uppercase mb-3 block">FAQ</span>
            <h2 className="text-4xl md:text-5xl font-black text-[#1a1a1a] leading-tight mb-6">
              Common Questions<br />Answered
            </h2>
            <p className="text-[#555] text-sm leading-relaxed mb-8">
              Have more questions? Our team is ready to help. Call us directly or schedule a free inspection and we'll walk you through everything.
            </p>
            <div className="flex flex-col gap-3">
              <a
                href="tel:2813779180"
                className="inline-flex items-center gap-3 bg-[#1a1a1a] hover:bg-[#c0392b] text-white font-bold px-7 py-3.5 rounded-full text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line"></i>
                Call (281) 377-9180
              </a>
              <a
                href="mailto:info@praroof.com"
                className="inline-flex items-center gap-3 bg-white border border-[#e0e0e0] hover:border-[#c0392b] text-[#1a1a1a] font-bold px-7 py-3.5 rounded-full text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-line text-[#c0392b]"></i>
                info@praroof.com
              </a>
            </div>
          </div>

          {/* Right Accordion */}
          <div className="lg:w-7/12 flex flex-col gap-3">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="bg-white rounded-xl overflow-hidden border border-[#e8e8e8] hover:border-[#c0392b]/30 transition-colors duration-200"
              >
                <button
                  className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                  onClick={() => setOpen(open === i ? null : i)}
                >
                  <span className="text-[#1a1a1a] font-semibold text-sm">{faq.q}</span>
                  <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${open === i ? 'bg-[#c0392b] rotate-45' : 'bg-[#f5f4f2]'}`}>
                    <i className={`ri-add-line text-sm ${open === i ? 'text-white' : 'text-[#1a1a1a]'}`}></i>
                  </div>
                </button>
                <div className={`overflow-hidden transition-all duration-300 ${open === i ? 'max-h-48' : 'max-h-0'}`}>
                  <p className="px-5 pb-5 text-[#666] text-sm leading-relaxed">{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
